<template>
    <div class="question-container">
        <div>
            <div class="title-wrapper">
                <img src="@/assets/img/question.png" alt="" class="title-img">
                <span class="title-label">管理会计准则</span>
            </div>
            <div class="question-title-wrapper">
                <div class="question-title">
                    韩十一：管理会计准则有哪些？
                </div>
                <div class="question-title-date">
                    2020-12-24 16:25
                </div>
            </div>
            <div class="question-content-wrapper">
                <div class="question-content">
                    答疑：学员您好，财务战略分析一共分为两种：财务分析和战略分析。
                    财务战略分析一共分为两种：财务分析和战略分析。财务战略分析一共
                    分为两种：财务分析和战略分析。
                </div>
                <div class="question-content-date">2020-12-24 18:25</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    props:{
        questionId:Number
    },
    components:{
      
    },
    data() {
        return {
            
        }
    },
    mounted(){
        
    },
    methods: {
        
    }
}
</script>

<style scoped>
.question-container{
    min-height:600px;
}
.title-wrapper{
    display:flex;
    align-items: center;
}
.title-img{
    width:21px;
    height:24px;
    display: inline-block;
    position:relative;
    top:2px;
}
.title-label{
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    margin-left:5px;
}
.question-title-wrapper{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top:16px;
}
.question-title{
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
}
.question-title-date{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9B9FAA;
}
.question-content-wrapper{
    display: flex;
    justify-content: space-between;
    margin-top:24px;
    padding-bottom:40px;
    border-bottom:solid #F0F0F0 1px;
}
.question-content{
    width:496px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
}
.question-content-date{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9B9FAA;
    height:100%;
}
</style>


